module.exports = __webpack_public_path__ + "3a08419eb78e7dc74a6f847f8b8ced02.svg";